import { QUERY_fetchOrderBidders } from 'queries';
import { createApolloCache, createApolloClient } from 'providers/ApolloProvider';
import { Order } from 'types/graphql';

const requestAwardTeamClient = createApolloClient({ cache: createApolloCache() });

export type AwardTeamMemberData = { order: Order };

export const requestAwardTeamConfig = ({ orderId }: { orderId: string }) => ({
  key: 'FETCH_ORDER_BIDDERS',
  query: QUERY_fetchOrderBidders,
  client: requestAwardTeamClient,
  responseTransformer: (rawData: { node?: unknown }): AwardTeamMemberData => {
    const node = rawData?.node;
    if (!node) return null as unknown as AwardTeamMemberData;
    return { order: node as Order };
  },
  schema: {
    orderId: {
      initialValue: orderId,
    },
    byMultipleFields: {
      initialValue: '',
    },
    byEmploymentStatus: {
      initialValue: [],
    },
  },
});
